import React from 'react';
import Link from 'next/link';
import { Image } from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { urlForImage } from '../../libs/sanity.image';

interface CoverImageProps {
  title: string;
  slug?: string;
  image: any;
}

export default function CoverImage(props: CoverImageProps) {
  const { title, slug, image: source } = props;
  // eslint-disable-next-line no-underscore-dangle
  const image = source?.asset?._ref ? (
    <Image
      as={motion.img}
      w='full'
      h='auto'
      className='h-auto w-full'
      alt={`Cover Image for ${title}`}
      src={urlForImage(source).height(1000).width(2000).url()}
      borderRadius='lg'
      boxShadow='xl'
    />
  ) : (
    <div style={{ paddingTop: '50%', backgroundColor: '#ddd' }} />
  );

  return (
    <div className='sm:mx-0'>
      {slug ? (
        <Link href={`/posts/${slug}`} aria-label={title}>
          {image}
        </Link>
      ) : (
        image
      )}
    </div>
  );
}
